module.exports = __webpack_public_path__ + "static/media/MAN PP 2020 NOVO PORT.d58dcb0c.pdf";